import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
	const { userData, isLoadingUser } = useContext(CombinedContext);
	const location = useLocation();

	// 🟦 1) Paddle Checkout Detection → ALWAYS ALLOW
	const params = new URLSearchParams(location.search);
	if (params.has("_ptxn")) {
		return children;
	}

	// 🟦 2) Wait for user to load normally
	if (isLoadingUser) {
		return <div>Checking authentication...</div>;
	}

	const user = userData?.user;
	const role = user?.role || "guest";

	// 🟦 3) Guest handling
	if (role === "guest") {
		if (allowedRoles?.includes("guest")) return children;
		return <Navigate to="/signin" state={{ from: location }} replace />;
	}

	// 🟦 4) Redirect owners/admin/staff AWAY from homepage root
	if (location.pathname === "/") {
		if (role === "owner") return <Navigate to="/profile" replace />;
		if (role === "admin") return <Navigate to="/profile" replace />;
		if (role === "staff") return <Navigate to="/calendar" replace />;
	}

	// 🟦 5) Standard role protection
	if (allowedRoles && !allowedRoles.includes(role)) {
		return <Navigate to="/" replace />;
	}

	return children;
};

export default ProtectedRoute;
